(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //  Context is a network
    //

  function pxCreateAnywhereQueue(
    toastr, $filter, $timeout
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/secureSettings/createAnywhereQueue/createAnywhereQueue.template.html',
      link: function(scope) {

        scope.queueNameInvalid = false;
        scope.focus = false;

        (function() {
          scope.printQueue = {
            name: '',
            activate: true
          }
        })();

        $timeout(function () {
          scope.focus = true;
        }, 300)

        scope.checQueuekName = function () {
          if (scope.printQueue.name) {
            if (scope.printQueue.name.match(/[\\,]/)) {
              scope.queueNameInvalid = true;
            } else {
              scope.queueNameInvalid = false;
            }
          }
        }

        scope.addPrintQueue = function() {
          scope.context.anywherePrinter.createPrintQueue(
            {
              active: scope.printQueue.activate,
              name: scope.printQueue.name
            }
          ).then(function(){
            toastr.success($filter("translate")("ChangesSaved"));
          }).catch(function(error){});
          scope.callback();
        };


      }
    };
  }

  pxCreateAnywhereQueue.$inject = ['toastr', '$filter', '$timeout'];

  angular
    .module('printix-admin')
    .directive('pxCreateAnywhereQueue', pxCreateAnywhereQueue);

})();
